import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ChallengeHistory} from '../challenge.model';
import { DecimalPipe, formatDate } from "@angular/common";
import { GridOptions } from 'ag-grid-community';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'cv-cxone-challenge-history-modal',
  templateUrl: './cxone-challenge-history-modal.component.html',
  styleUrl: './cxone-challenge-history-modal.component.scss'
})
export class CxoneChallengeHistoryModalComponent implements OnInit {

    DateFormat = "MMM d, y";
    challengeHistory: ChallengeHistory[] = this.dialogConfig.data.challenges;
    allowClose: boolean = true;
    headerTitle: string = this.dialogConfig.data.headerTitle;
    saveLabel: string = this.dialogConfig.data.saveLabel;
    getLocalizationString: (key: string, defaultValue: string) => string = this.dialogConfig.data.getLocalizationString;
    gridOptions: GridOptions = null;
    localizationStrings: Map<string, string> = new Map<string, string>();

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private dialogConfig: DynamicDialogConfig,
        private decimalPipe: DecimalPipe,
        private dialogRef: DynamicDialogRef
    ){}

    async ngOnInit() {
        await this.loadInformation();
    }

    async loadInformation() {
        this.setupGrid();
    }

    onDismiss() {
        this.dialogRef.close();
    }
    
    onClose() {
        this.dialogRef.close();
    }

    getFormattedDate(date: Date): string {
        return formatDate(date, this.DateFormat, this.locale);
    }
    
    setupGrid() {
        this.gridOptions = {
            suppressDragLeaveHidesColumns: true,
            suppressRowGroupHidesColumns: true,
            suppressContextMenu: true,
            animateRows: true,
            suppressCellFocus: true,
            alwaysShowVerticalScroll: false,
            rowHeight: 36,
            headerHeight: 44,
            suppressPreventDefaultOnMouseWheel: true,
            enableBrowserTooltips: false,
            overlayNoRowsTemplate: `<div class="error-container">
                                        <svg class="cxoneFavoriteState mb-2" style="width: 165.94px !important;height:92px !important;">
                                            <use href="../App_Themes/CXone/icons/no-results-big.svg#no-results-big"></use>
                                        </svg>
                                        <p class="cxone-error-text" style="color:#758994;">${this.getLocalizationString("No_History_Found", "No history found")}</p>
                                    </div>`,
            columnDefs: [
                {
                    headerName: this.getLocalizationString("Date", "Date"),
                    sortable: true,
                    field: 'EndDate_ForView',
                    valueFormatter: (params) => this.getFormattedDate(params.value),
                    comparator: (valueA: string, valueB: string) => {
                        const dateA = new Date(valueA);
                        const dateB = new Date(valueB);
                        return dateA.getTime() - dateB.getTime();
                    },
                },
                {
                    headerName: this.getLocalizationString("Metric", "Metric"),
                    field: 'Metrics',
                    sortable: true,
                },
                {
                    headerName: this.getLocalizationString("Status", "Status"),
                    field: "Rank",
                    sortable: true,
                    valueGetter: (params) => params.data.Rank === "1st" ? this.getLocalizationString('Won','Won') : this.getLocalizationString('Lost','Lost'),
                },
                {
                    headerName: this.getLocalizationString("Created_By", "Created By"),
                    field: "CreatorName",
                    sortable: true,
                },
                {
                    headerName: this.getLocalizationString("Coins", "Coins"),
                    field: "Wager",
                    sortable: true,
                    valueFormatter:(params) => this.decimalPipe.transform(parseFloat(this.getCoinsValue(params.data)), undefined, CVCultureName)
                },
            ],
            defaultColDef: {
				suppressMenu: true,
            },
            rowData: this.challengeHistory,
            onGridSizeChanged(event) {
				event.api.sizeColumnsToFit();
			},
            onGridReady: (params) => {
                if (params.api.getDisplayedRowCount() === 0) {
                    params.api.showNoRowsOverlay();
                }
                else {
                    params.api.hideOverlay();
                }
                params.api.sizeColumnsToFit();
            },
        }
    }

    getCoinsValue(data: any) {
        if (data.Rank !== "1st") return data.Wager;
        
        const myRank = data.Rankings?.find((rank) => rank.IsMe);
        return myRank?.Reward || 0;
    }
}
